import React from "react";
import { Link } from "react-router-dom";
import useSeo from "../hooks/useSeo";
import { storeConfig } from "../config/store.config";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1618924250113-e162305ac8cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

const About = () => {
  useSeo({
    title: "About",
    description: "About 9'One Store — a contemporary fashion label focused on premium everyday t-shirts and streetwear essentials.",
    path: "/about",
  });

  return (
    <div className="animate-fade-in">
      <div className="border-b border-ink">
        <div className="container-9one py-16 text-center">
          <p className="label-mono text-ink/50">{storeConfig.tagline}</p>
          <h1 className="mt-4 font-display text-6xl uppercase leading-none tracking-tight sm:text-8xl">
            9'One Store
          </h1>
        </div>
      </div>

      <div className="container-9one grid items-center gap-12 py-16 lg:grid-cols-2 lg:gap-20">
        <div className="aspect-[4/5] overflow-hidden bg-cream">
          <img src={ABOUT_IMG} alt="9'One Store" className="h-full w-full object-cover grayscale" />
        </div>
        <div>
          <h2 className="font-display text-4xl uppercase tracking-tight sm:text-5xl">
            Premium tees,<br />monochrome soul
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/70">
            <p>
              9'One Store is a contemporary fashion label focused on premium
              everyday t-shirts and streetwear essentials.
            </p>
            <p>
              We believe in considered fits, quality fabrics and a clean,
              monochrome aesthetic — pieces designed to be worn on repeat.
            </p>
            <p className="text-ink/40">
              (This is editable placeholder copy. No factual claims — history,
              awards or manufacturing details — are stated until confirmed.)
            </p>
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/shop" className="btn-solid" data-testid="about-shop-cta">Shop the Collection</Link>
            <Link to="/contact" className="btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>

      <section className="bg-cream py-16">
        <div className="container-9one grid gap-8 sm:grid-cols-3">
          {[
            { t: "Considered Fits", d: "Oversized, relaxed and regular silhouettes." },
            { t: "Premium Fabric", d: "Soft, durable cotton built to last (specs TBC)." },
            { t: "Order via WhatsApp", d: "Simple, direct ordering with our team." },
          ].map((x) => (
            <div key={x.t} className="border border-ink p-8">
              <h3 className="font-display text-2xl uppercase tracking-tight">{x.t}</h3>
              <p className="mt-2 text-sm text-ink/60">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
